/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import {
	LOGIN_LESS_SUBMIT,
	GA4_EVENT_LOGIN_LESS_SUBMIT,
	PAGE_DATA_LAYER,
} from '@/data/constants/gtm';
import { getGTMLoginLessSubmitEventData } from '@/data/events/data/gtm/LoginLessSubmit';
import { getGTMConfig } from '@/data/events/handlers/gtm';
import { GTMLoginLessSubmitPayload } from '@/data/types/GTM';
import { error as logError } from '@/data/utils/loggerUtil';
import TagManager from 'react-gtm-module';

export const measure_GA4 = async (
	data: Awaited<ReturnType<typeof getGTMLoginLessSubmitEventData>>
) => {
	const dataLayerName = PAGE_DATA_LAYER;

	const tagManagerArgs = {
		dataLayer: {
			event: GA4_EVENT_LOGIN_LESS_SUBMIT,
			...data,
		},
		dataLayerName,
	};
	TagManager.dataLayer(tagManagerArgs);
};

export const measure_UA = async (
	data: Awaited<ReturnType<typeof getGTMLoginLessSubmitEventData>>
) => {
	const dataLayerName = PAGE_DATA_LAYER;

	const tagManagerArgs = {
		dataLayer: {
			event: LOGIN_LESS_SUBMIT,
			...data,
		},
		dataLayerName,
	};
	TagManager.dataLayer(tagManagerArgs);
};

export const sendGTMLoginLessSubmitEvent = async (payload: GTMLoginLessSubmitPayload) => {
	const { ga4, ua } = getGTMConfig(payload.settings);

	if (ua || ga4) {
		const data = await getGTMLoginLessSubmitEventData(payload);
		if (ua) {
			try {
				await measure_UA(data);
			} catch (error) {
				logError(
					undefined,
					'LoginLessBegin: sendGTMLoginLessSubmitEvent: measure_UA: error: %o',
					error
				);
			}
		}

		if (ga4) {
			try {
				await measure_GA4(data);
			} catch (error) {
				logError(
					undefined,
					'LoginLessBegin: sendGTMLoginLessSubmitEvent: measure_GA4: error: %o',
					error
				);
			}
		}
	}
};
